import { truncateLongName } from '../../utils/util';

const getTitleHeader = props => {
  // secondaryAddress
  if (props.isSecondary) {
    const secondaryName = truncateLongName(props.secondaryName);
    if (props.secondaryUsePrimaryAddress) {
      return {
        title: `${secondaryName}, is this your address too?`,
        header: `Many co-borrowers share an address. If you have separate addresses,
            please uncheck the box and enter ${secondaryName}’s address.`,
      };
    }

    return {
      title: `${secondaryName}, what’s your home address?`,
      header: `We’ll use this to make sure we found the right ${secondaryName}.`,
    };
  }

  // DM with complete PII or secondLoan primaryAddress
  if (props.streetAddress && ((props.isDM && !props.hasPartialDMPII) || props.isSecondLoan)) {
    // Experian DM
    if (props.isExperianDm) {
      const primaryFirstName = truncateLongName(props.primaryName.firstName);
      const primaryLastName = truncateLongName(props.primaryName.lastName);
      return {
        title: `Welcome ${primaryFirstName} ${primaryLastName}!`,
        header:
          'Is this your correct address? We need this to find your credit report, which helps us calculate your rate.',
      };
    }
    const header = 'We need this to find your credit report, which helps us calculate your rate.';
    // regular DM or secondLoan user
    return {
      title: 'Is this your correct address?',
      header,
    };
  }

  // non DM or DM with missing PII
  return {
    title: 'What’s your home address?',
    header: `Let’s make sure we find the right ${props.primaryName.firstName}.`,
  };
};

export default getTitleHeader;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/Address/Address.scss');